import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-confirm-delete-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 w-full max-w-sm mx-4 p-6">
        <div class="flex items-start gap-3 mb-4">
          <div class="flex-shrink-0 w-9 h-9 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
            <svg class="w-5 h-5 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <div>
            <h3 class="text-base font-semibold text-gray-900 dark:text-white">{{ title || (count === 1 ? 'Delete file' : 'Delete ' + count + ' files') }}</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {{ description || ('This will remove the ' + (count === 1 ? 'file' : 'files') + ' from the browser.') }}
            </p>
          </div>
        </div>

        <div class="flex justify-end gap-2">
          <button
            (click)="cancel.emit()"
            class="px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
            Cancel
          </button>
          <button
            (click)="confirmed.emit()"
            class="px-4 py-2 text-sm rounded-lg bg-red-600 hover:bg-red-700 text-white font-medium transition-colors">
            Delete
          </button>
        </div>
      </div>
    </div>
  `
})
export class ConfirmDeleteDialogComponent {
  @Input() count = 1;
  @Input() title = '';
  @Input() description = '';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}